export const primary = '#228FF8'
export const secondary = '#EC1C24'
export const blue = '#4285F4'
export const white = '#FFFFFF'
export const black = 'black'
export const red = 'red'
export const green = 'green'
export const deepskyblue = 'deepskyblue'
export const grey = 'grey'
export const grey_191 = '#bfbfbf'
export const grey_title = '#7c7c7c'
export const grey_Card_BackGround = '#f5f5f5'
export const cardBackGroudRed = '#ffc8cb'
export const headerColorRed = '#cd002d'
export const footerColorGray = '#242424'
export const textHeadingColor = '#585858'
export const customErrorMsg = '#ff4d4f'

// // bg-color header #cd002d

// text red color #f91c47
// text heading color #585858
// text sub heading color #888888
// text color #8c8c8c

// // footer color #242424
